/* Class that represents the redux beacon target to track RUM events */
class SpeedcurveRum {
  constructor() {
    this.target = (events) => {
      if (!window.LUX) {
        return;
      }

      events.forEach((event) => {
        switch (event.type) {
          case 'conversionEvent':
          case 'timingMetric':
            window.LUX.addData(event.name, event.value);
            break;

          case 'markStart':
            window.LUX.mark(event.name);
            break;

          case 'markEnd':
            window.LUX.mark(event.markNameEnd);
            window.LUX.measure(event.measureName, event.markNameStart, event.markNameEnd);
            break;
          default:
            break;
        }
      });
    };
  }

  getTarget() {
    return this.target;
  }
}

export default SpeedcurveRum;
